import { Box, Container, Grid, Link, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React, { useEffect, useState } from 'react'
import TrackVisibility from 'react-on-screen';
import 'animate.css';

const useStyles = makeStyles ((theme) => ({
    banner: {
        height: {xs: 'none', md: '100vh'},
        marginTop: '0',
        backgroundColor: "#fff",
        padding: '260px 0 100px 0',
        // border: '1px solid yellow'
    },
    // bannerGrid: {
    //     backgroundColor: "yellow",
    //     paddingTop: '50px',
    //     paddingBottom: '50px',
    //     alignItems: "center"
    // },
    spanbody: {
        fontFamily: 'Inter',
        color: "#000",
        fontWeight: '700',
        fontSize: '18px'
    },
    vvdlink: {
        fontFamily: 'Inter',
        margin: "40px 0 40px",
        fontWeight: 700,
        textTransform: 'uppercase',
        textDecoration: 'none !important',
        padding: '15px 50px',
        borderRadius: '4px',
        // textAlign: 'center',
        color: '#000 !important',
        width: '250px',
        fontSize: '1em',
        // border: 'solid 2px #fdf289',
        background: '#fca311',
        transition: '0.4s ease-in-out',
        cursor: 'pointer',

        '&:hover': {
            color: '#b9e3e2',
            background: '#fdf289',
            border: '0',
        }
    },
}));

const Banner = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const toRotate = ["Frontend Developer", "Tech Support"];
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(300 - Math.random() * 100);
    const period = 2000;

    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

        setText(updatedText);

        if (isDeleting) {
            setDelta(prevDelta => prevDelta /2)
        }

        if (!isDeleting && updatedText === fullText) {
            setIsDeleting(true);
            setDelta(period);
        } else if (isDeleting && updatedText === '') {
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(500);
        }
    }

    useEffect(() => {
        let ticker = setInterval(() => {
            tick();
        }, delta)
        return () => {clearInterval(ticker)};
        //eslint-disable-next-line
    }, [text, delta])


    const classes = useStyles();
  return (
    <div className={`${classes.banner} ${'banner'}`} id='home'>
        <Container>
            <Box 
                sx={{display: 'block', margin: '0 auto', width:{xs: '100%', sm:'90%', md: '80%' }, textAlign: 'center',}}
                // className={`${'banner-center'}`}
            
            >
                <Grid container spacing={2} className={classes.bannerGrid}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <TrackVisibility>
                            {({ isVisible }) => 
                                <div 
                                    
                                    style={{
                                        display: "flex",
                                        flexDirection: 'column',
                                        justifyContent: "space-between",
                                    }}
                                >   
                                    <div className={isVisible ? "animate__animated animate__bounceInDown animate__delay-0.5s" : ""}>
                                        <Typography
                                            variant='h2'
                                            style={{
                                                fontFamily: 'Inter',
                                                fontSize: {xs: '28px', sm: '50px', md: '80px'}, 
                                                lineHeight: {xs: '32px', sm: '54px', md: '84px'},
                                                color: '#000',
                                                fontStyle: 'normal',
                                                textTransform: 'capitalise',
                                                fontWeight: '700', 
                                                letterSpacing: '0.85px',
                                                // padding: '8px 10px',
                                                marginBottom: '16px',
                                            }}
                                        >
                                            {text}
                                        </Typography>
                                    </div>
                                    <div className={isVisible ? "animate__animated animate__bounceInDown animate__delay-1s" : ""}>
                                        <Typography
                                            variant='body1'
                                            style={{
                                                // fontFamily: 'Inter',
                                                color:'#000',
                                                fontSize: '18px',
                                                fontWeight: '500',
                                                letterSpacing: '0.75px',
                                                width: '96%',
                                                lineHeight: '1.5em',
                                                marginTop: "20px",
                                            }}
                                        >
                                            I'm a dynamic MERN stack developer with technical support Tier 2 skills, who specializes in creating stunning frontend UIs and seamless backend integrations using
                                            {' '} 
                                            <span className={classes.spanbody}>
                                                React.js, JavaScript,
                                            </span> {''} 
                                            <span className={classes.spanbody}>Nodejs</span> and <span className={classes.spanbody}>MongoDb</span> database.
                                            Let's bring your ideas to life!
                                            
                                        </Typography>
                                   
                                        <Box sx={{margin: '50px 0'}}>
                                            <div >
                                                <Link href="#contact" className={classes.vvdlink}>
                                                    Hire Me
                                                </Link>
                                            </div>

                                            <Box className={`${'social-icon'}`} sx={{display: {xs: "flex", sm: 'flex', md: "none"}, margin: '40px 0 0', alignItems:  'center', justifyContent: 'center'}}>
                                            <a href='https://www.linkedin.com/in/aniekan-edet-03521a96/' target='_blank' rel='noreferrer'>
                                                <img src='/images/nav-icon1.svg' alt='facebook-link' />
                                            </a>
                                            <a href='https://web.facebook.com/AniekangEdet' target='_blank' rel='noreferrer'>
                                                <img src='/images/nav-icon2.svg' alt='linkedIn-link' />
                                            </a>
                                            <a href='http://www.twitter.com/agedet9060' target='_blank' rel='noreferrer'>
                                                <img src='/images/nav-icon4.svg' alt='twitter-link' />
                                            </a>
                                            <a href='http://www.github.com/agedet' target='_blank' rel='noreferrer'>
                                                <img src='/images/nav-icon6.svg' alt='twitter-link' />
                                            </a>
                                            </Box>
                                        </Box> 
                                    </div>
                                </div>
                            }
                        </TrackVisibility>
                    </Grid>
                    {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6} >
                        <Box sx={{ 
                                display: {xs: 'none', sm: 'none', md: 'flex' },
                                justifyContent: "center", 
                                alignItems: "center", 
                            }}
                        >
                            <span className='banner-img'>
                                <img src='/images/language-vector-bg.png' alt='devmode' height="100%" width="100%" />
                            </span>
                        </Box>
                    </Grid> */}
                </Grid>
            </Box>
        </Container>
    </div>
  )
}

export default Banner